import { render, staticRenderFns } from "./RegisterForm3.vue?vue&type=template&id=bcf06598&scoped=true&"
import script from "./RegisterForm3.vue?vue&type=script&lang=js&"
export * from "./RegisterForm3.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm3.vue?vue&type=style&index=0&id=bcf06598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf06598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf06598')) {
      api.createRecord('bcf06598', component.options)
    } else {
      api.reload('bcf06598', component.options)
    }
    module.hot.accept("./RegisterForm3.vue?vue&type=template&id=bcf06598&scoped=true&", function () {
      api.rerender('bcf06598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterForm3.vue"
export default component.exports